import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Error from './shared/Error';
import Landing from './pages/Landing';
import Layout from './shared/Layout';
import AskGuardian from './pages/AskGuardian';
import { Provider } from 'react-redux';
import { store } from './store/store';
import KPIReporting from './pages/KPIReporting';
import DeviationRadarSitesView from './pages/DeviationRadarSitesView';
import DeivationRadarAreasView from './pages/DeviationRadarAreasView';
import DeviationRadar from './pages/DeviationRadar';
import { APP_ROUTES } from './constants/AppRoutes';
import { StrictMode } from 'react';

const routes = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <Error />,
    children: [
      {
        path: "/",
        element: <Landing />
      },
      {
        path: `${APP_ROUTES.ASK_GUARDIAN}/:threadId?`,
        element: <AskGuardian />
      },
      {
        path: `${APP_ROUTES.DEVIATION_RADAR}`,
        element: <DeviationRadar />
      },
      {
        path: `${APP_ROUTES.DEVIATION_RADAR}/:area?`,
        element: <DeviationRadarSitesView />
      },
      {
        path: `${APP_ROUTES.DEVIATION_RADAR}/:area?/:areaCode`,
        element: <DeivationRadarAreasView />
      },
      {
        path: `${APP_ROUTES.KPI_REPORTING}`,
        element: <KPIReporting />
      }
    ]
  }
]);

function App() {
  return (
    <Provider store={store}>
      <StrictMode>
        <RouterProvider router={routes} />
      </StrictMode>
    </Provider>
  );
}

export default App;
